export const dismissInitialLoadingScreen = () => {
  document.getElementById('initial-loading-screen')?.remove();
};
